import { bookApi } from 'api'
import router from '@/router'
import bookTools from '@/utils/book'

const state = {
  book: {
    pages: []
  }
}

const getters = {
  book: state => state.book,
  pages: state => state.book.pages,
  chapters: state => state.book.chapters,
  numberOfPages: state => state.book.pages.length,
  pageByPageNumber: (state) => (pageNumber) => {
    return state.book.pages.length ? state.book.pages.find(p => p.pageNumber === pageNumber) : null
  },
  attachments: (state) => {
    return state.book.pages.filter(p => p.attachments.length).map(p => {
      return {
        pageNumber: p.pageNumber,
        attachments: p.attachments
      }
    })
  },
  audios: (state) => {
    const audios = []
    state.book.pages.filter(p => p.attachments.length).forEach(element => {
      element.attachments.filter(attachment => attachment.type === 'Audio').forEach(audio => {
        audios.push(audio)
      })
    })

    return audios
  },
  hyperlinks: (state) => {
    return state.book.pages.filter(p => p.hyperlinks.length).map(p => {
      return {
        pageNumber: p.pageNumber,
        hyperlinks: p.hyperlinks
      }
    })
  },
  currentPageNumber: (state, getters, rootState, rootGetters) => {
    return Number(rootState.route.params.pageNumber)
  },
  currentPage: (state, getters) => {
    return getters.pageByPageNumber(getters.currentPageNumber)
  },
  evenPage: (state, getters) => {
    let currentPage = getters.currentPageNumber
    if (!bookTools.isEven(currentPage)) {
      currentPage = currentPage - 1
    }
    return getters.pageByPageNumber(currentPage) || null
  },
  oddPage: (state, getters) => {
    let currentPage = getters.currentPageNumber
    if (bookTools.isEven(currentPage)) {
      currentPage = currentPage + 1
    }
    return getters.pageByPageNumber(currentPage) || null
  }
}

const actions = {
  getBook ({ commit }, id) {
    return bookApi.get(id).then(resp => {
      document.title = `${resp.data.title} | ${document.title}`
      commit('setBook', resp.data)
      commit('setHidePageElements', resp.data.hidePageElements)
    }).catch(() => router.replace('/notfound'))
  },
  goToPreviousPage ({ commit, getters, rootGetters }) {
    let previousPage = getters.currentPageNumber

    if (rootGetters.spread) {
      previousPage -= bookTools.isEven(previousPage) ? 2 : 3
    } else {
      previousPage -= 1
    }

    previousPage = previousPage < 1 ? 1 : previousPage

    router.push({ params: { pageNumber: previousPage } })
  },
  goToNextPage ({ commit, getters, rootGetters }) {
    const displayPages = (rootGetters.spread && bookTools.isEven(getters.currentPageNumber)) ? 2 : 1
    let nextPage = getters.currentPageNumber

    nextPage += nextPage + displayPages > getters.pages.length ? 0 : displayPages

    router.push({ params: { pageNumber: nextPage } })
  }
}

const mutations = {
  setBook (state, book) {
    state.book = book
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
